// TABLE_NAME: PlanesEstrategicosDetallesCamposFuentes
export const WEB_SERVICE = 1;
export const STORED_PROCEDURE = 2;
export const FIXED_VALUE = 3;
